import DialogWrapper from './dialog-wrapper';
import useDialog, { closeDialog, getDialog, showDialog } from './use-dialog';

export {
  DialogWrapper,
  useDialog,
  closeDialog,
  getDialog,
  showDialog,
}